<template>
	<div class="details">
		<ControlLevel :controlLevelDto="edisetup.controlLevelDto"/>
	</div>
</template>

<script>
import ControlLevel from '../common/ControlLevel.vue';

export default {
	components: { ControlLevel },
	props: {
		messageMetadata: Object,
		edisetup: Object
	}
};
</script>

<style lang="scss" scoped>

.details{
	display: grid;
	grid-template-columns: 300px 150px 250px 100px;
	column-gap:40px;
	row-gap: 40px;
}
</style>